import React, { Component } from "react";
import Select from 'react-select';
// Reemplazo del antiguo react-dates por react-date-range compatible con React 17
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import moment from 'moment';
import 'moment/locale/es';
import '../styles/datepicker-override.css';
import '../styles/pagination-override.css';
import ReactPaginate from 'react-paginate';
import { LangContext } from "../LangContext.jsx";
import SimplePagination from "./SimplePagination";
import { zhCN } from "date-fns/locale";
import { reject } from "lodash";
moment.locale('es');
class ReportsDocuments extends Component {
    hasDoc2SignEnabled = () => {
        return this.props.has_doc_2_sign_enabled === true || this.props.has_doc_2_sign_enabled === 'true';
    }

    getDocumentActionUrl = (document) => {
        if (!document || document.status.id === 1) {
            return null;
        }

        if (document.provider.type === 2) {
            return null;
        }

        const personProviderId = document.person_providers_id;
        const documentId = document.id;

        if (!personProviderId || !documentId) {
            return null;
        }

        if (document.status.id === 2) {
            return `/document_dossier/${personProviderId}/review_file/${documentId}`;
        }

        if (document.status.id === 1 || document.status.id === 5) {
            return `/document_dossier/${personProviderId}/new_file/${documentId}`;
        }

        return `/document_dossier/${personProviderId}/show_file/${documentId}`;
    }

    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = { 
            page: 1,
            total: 0, 
            maxRecords: 10,
            documents: [],
            shownFields: {},
            filters: {},
            documentTitles: [],
            fiscalNames: [],
            showAdvancedFilters: false,           
            rangeDate:'',
            showDatePicker: false,
            showExport: true,
            showExportOptions: false,
            showColumnSelector: false, 
            total_constancias:0,
            total_imss:0,
            total_repse:0,
            total_infonavit:0,
            total_sat:0,
            columns_head: {
                'file.title_head': true, 
                'dossier':true, 
                'extension':true,
                'frequency':true,
                'status':true,
                'document_template':true,
                'relation':true,
                'type':true,
                'fiscal_name':true,
                'rfc':true,
                'fields':true,
                'requested_date':true,
                'upload_date':true,
                'rejected_message':true,
            },
            options: 
                {
                    showRejectedFiles: false,
                    extensions: {
                        "pdf": "PDF",
                        "svg": "SVG",
                        "jpeg,jpg": "JPG",
                        "png": "PNG",
                        "xml": "CFDI",
                        "xlsx,xls": "XLS",
                        "doc,docx": "DOC",
                        "zip": "ZIP"
                    },
                    tipo_expediente: {
                        1:'Externo',
                        2:'Interno',
                        3:'Propio'
                    },
                    frequency: {
                        "once":'Única',
                        "yearly":'Recurrente', 
                    },
                    status: {
                        "1":'Por Cargar',
                        "2":'Por Revisar', 
                        "6": (props.has_doc_2_sign_enabled === true || props.has_doc_2_sign_enabled === 'true') ? 'Por Firmar' : 'Por Revisar',
                        "3":'Aprobado / Firmado',  
                        "4":'Rechazado',   
                        "5":'Histórico',   
                    },
                    startDate: null,
                    endDate: null,
                    target: {
                        "1":'Cliente',
                        "2":'Proveedor', 
                        "3":'Empleado', 
                        "4":'Propio',  
                    },
                    type: { 
                        "1":'Nacional', 
                        "2":'Internacional', 
                        "3":'Especiales', 
                        "4":'Otros', 
                    },
            }
        }
        this.datePickerRef = React.createRef();
    }  
    
    getDocuments(exportFiles = false, type = null, visibleColumns = null) { 
        window.blockUI();
        let url = '/api/reports/documents/';
        const query = new URLSearchParams({
            page: this.state.page,
            maxRecords: this.state.maxRecords,
            ...this.state.filters // Agrega dinámicamente los filtros activos
        }); 
        query.append('exportFiles', exportFiles);
        query.append('exportType', type);
        
        // Si estamos exportando y tenemos columnas visibles, las enviamos al backend
        if (exportFiles && visibleColumns) {
            query.append('visibleColumns', JSON.stringify(visibleColumns));
        }
        axios.get(`${url}?${query}`).then(res => {  
            if(exportFiles){
                let title;
                let html; 
                if(type == 'document'){
                    title = 'Descarga masiva de documentos en proceso';
                    html = 'Tu solicitud de descarga de documentos masiva está en proceso.<br> En breve te compartiremos la liga al correo electrónico registrado.'
                }
                if(type == 'constancia' || type == 'sat' || type == 'imss' || type == 'repse' || type == 'infonavit'){
                    title = 'Generación Reporte de documentos campos extra en proceso';
                    html = 'Tu solicitud de reporte está en proceso..<br> En breve te compartiremos la liga al correo electrónico registrado.'
                }
                if(type == 'compact'){
                    title = 'Generación Reporte de documentos compacto en proceso';
                    html = 'Tu solicitud de reporte está en proceso.<br> En breve te compartiremos la liga al correo electrónico registrado.'
                }
                if(res.data.in_process == true){
                    Swal.fire({
                        title: title,
                        html: 'Tienes un reporte en proceso, intentalo de nuevo mas tarde',
                        icon: 'info',
                        confirmButtonText: 'Aceptar',
                        buttonsStyling: false, 
                        customClass: {
                            confirmButton: "btn font-weight-bold btn-primary"
                        }
                        });
                }else
                {
                    Swal.fire({
                        title: title,
                        html: html,
                        icon: 'info',
                        confirmButtonText: 'Aceptar',
                        buttonsStyling: false, 
                        customClass: {
                            confirmButton: "btn font-weight-bold btn-primary"
                        }
                        });
                }       
            } else{
                const filteredDocuments = res.data.data.filter(doc => doc.status.id !== 1);
                console.log('Total documents excluding status 1:',res.data.total_constancias);
                this.setState({ 
                    documents: res.data.data, 
                    total: res.data.total ,
                    total_excluding_status_1:res.data.total_excluding_status_1,
                    total_constancias:res.data.total_constancias,
                    total_imss:res.data.total_imss,
                    total_repse:res.data.total_repse,
                    total_infonavit:res.data.total_infonavit,
                    total_sat:res.data.total_sat
                });
            }
            window.unblockUI(); 
            this.getFilters(); 
        });
    }
    getFilters = () => {
        axios.get('/api/filters/documents', ).then((res) => {
            const documentFilters = res.data;
            this.setState({ 
                documentTitles: documentFilters.documentTitles,
                dossierTitles: documentFilters.dossierTitles,
                fiscalNames: documentFilters.fiscalNames,
                rfcs: documentFilters.rfcs,
            });
        });
    }

    clearDates = () => {
        this.setState(prevState => {
            const newFilters = { ...prevState.filters };
            delete newFilters.startDate;
            delete newFilters.endDate;
            return { filters: newFilters, startDate: null, endDate: null };
        }, this.getDocuments);
    };

    updateFilters = (filterKey, value) => {
        this.setState(prevState => {
            const newFilters = { ...prevState.filters };
            if (value !== null && value !== undefined) {
                newFilters[filterKey] = value; // Agrega el filtro solo si el valor no es null/undefined
            } else {
                delete newFilters[filterKey]; // Elimina el filtro si el valor es null/undefined
            } 
            return { filters: newFilters };
        }, this.getDocuments);
    };

    clearFilters = () => {
        this.setState({ filters: {} }, this.getDocuments);
    };

    updateCurrentPage = (page) => {
        this.setState({ page }, this.getDocuments);
    };

    componentDidMount() { 
        this.getDocuments(); 
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    toggleAdvancedFilters = () => {
        this.setState(prevState => ({
            showAdvancedFilters: !prevState.showAdvancedFilters
        }));
    };
    resetCurrentPage = () => {
        this.setState({
            currentPage: 0,
        });
    }
    handleExportClick = (type) => {
        // Pasar las columnas visibles al método getDocuments para la exportación
        this.getDocuments(true, type, this.state.columns_head);
        return; 
    } 
    handleClickOutside = (event) => {
        if (this.state.showDatePicker && this.datePickerRef && this.datePickerRef.current && !this.datePickerRef.current.contains(event.target)) {
            this.setState({ showDatePicker: false });
        }
    }
    toggleDatePicker = () => {
        this.setState(prev => ({ showDatePicker: !prev.showDatePicker }));
    }
    handleDateChange = (ranges) => {
        // react-date-range regresa un objeto con la key 'selection'
        const { startDate, endDate } = ranges.selection || {};
        this.resetCurrentPage();
        // Convertimos a string (YYYY-MM-DD) para filtros/API
        const startStr = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endStr = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        this.setState({ rangeDate: { startDate, endDate } });
        this.updateFilters('startDate', startStr);
        this.updateFilters('endDate', endStr);
        this.setState({ startDate, endDate });
        this.getDocuments();
        // no cerramos automáticamente; el usuario puede hacer click fuera para cerrar
    };
    toggleFields = (documentId) => {
        this.setState(prevState => ({
            shownFields: {
                ...prevState.shownFields,
                [documentId]: !prevState.shownFields[documentId]
            }
        }));
    }
    toggleColumnVisibility = (column) => {
        this.setState(prevState => ({
            columns_head: {
                ...prevState.columns_head,
                [column]: !prevState.columns_head[column]
            }
        }));
    };
    handleRejectedFiles = () => {
        this.setState(prevState => ({
            showRejectedFiles: !prevState.showRejectedFiles
        }), this.getDocuments);
    }
    render() {
        const { lang } = this.context; 
        const columnNames = {
            'file.title_head': lang.get('messages.plantilla_de_documento'),
            'dossier':lang.get('messages.plantilla_de_expediente'),
            'extension':lang.get('messages.extension'),
            'frequency':lang.get('messages.frecuencia'),
            'status':lang.get('messages.estatus'),
            'document_template':lang.get('messages.plantilla_de_documento'),
            'relation':lang.get('messages.relacion'),
            'type':lang.get('messages.tipo'),
            'fiscal_name':lang.get('messages.razon_social'),
            'rfc':lang.get('messages.rfc'),
            'fields':lang.get('messages.campos_extra'),
            'requested_date':lang.get('messages.fecha_de_solicitud'),
            'upload_date':lang.get('messages.fecha_de_carga'),
            'rejected_message':lang.get('messages.mensaje_de_rechazo'), 
        };
        const canExportCompactReport = this.props.permissions?.documents_actions?.includes('all') || this.props.permissions?.documents_actions?.includes('export_compact_report');
        const canExportExtraFieldsReportColumns = this.props.permissions?.documents_actions?.includes('all') || this.props.permissions?.documents_actions?.includes('export_extra_fields_report_columns');
        const canMassiveDownload = this.props.permissions?.documents_actions?.includes('all') || this.props.permissions?.documents_actions?.includes('massive_download');
        const canShowActionsButton = this.state.showExport && (canExportCompactReport || canMassiveDownload || canExportExtraFieldsReportColumns);

        const canSeeInternalDocumentsReport = this.props.permissions?.reports_list_internal?.includes('all') || this.props.permissions?.reports_list_internal?.includes('documents');
        const canSeeOwnDocumentsReport = this.props.permissions?.reports_list_own?.includes('all') || this.props.permissions?.reports_list_own?.includes('documents');
        const dossierTypeOptions = [{ value: '1', label: 'Externo' }];
        const statusName = (document) => {
            if (document.status.id === 3) {
                return this.hasDoc2SignEnabled() ? 'Aprobado / Firmado' : 'Aprobado';
            }

            if (document.status.id === 6 && !this.hasDoc2SignEnabled()) {
                return 'Por Revisar';
            }

            return document.status.name;
        };

        if (canSeeInternalDocumentsReport) {
            dossierTypeOptions.push({ value: '2', label: 'Interno' });
        }

        if (canSeeOwnDocumentsReport) {
            dossierTypeOptions.push({ value: '3', label: 'Propio' });
        }
        return (
            
            <> 
                <div className="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader"> 
                    <div className="container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                        <div>
                            <h5 className="text-dark font-weight-bold my-1 mr-5">
                                {lang.get('messages.reporte_de_documentos')} 
                            </h5>
                            <p className="text-dark-50 font-weight-bold my-1 mr-5">
                            
                                <span className="text-primary datatable-count">{this.state.total}</span> {lang.get('messages.documentos_en_la_plataforma')}
                            </p> 
                        </div> 
                        <div className="d-flex align-items-center flex-wrap"> 
                        {canShowActionsButton &&
                            <div>
                                <div className="dropdown dropdown-inline ">
                                <a href="#" className="btn btn-fixed-height btn-primary font-weight-bolder font-size-sm px-5" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {lang.get('messages.acciones')}
                                        &nbsp;&nbsp;
                                        <i className="flaticon2-down icon-sm"></i>
                                    </a> 
                                    <div className="dropdown-menu dropdown-menu-actions dropdown-menu-lg dropdown-menu-right p-0 m-0 rounded-lg"  > 
                                        <ul className="navi navi-hover">
                                        {canExportCompactReport && (
                                        <li class="navi-item  li-actions">
                                                <a  className="navi-link py-4" onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.handleExportClick("compact");
                                                }}>
                                                    <span className="navi-icon mr-5 text-center">
                                                        <span className="flaticon-download text-primary icon-md"></span>
                                                    </span>
                                                    <span className="navi-text text-secondary">Exportar Reporte Compacto</span>
                                                    <span className="navi-icon pull-right">
                                                        <button className="btn btn-icon btn-light btn-xs bg-white">
                                                            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                        </button>
                                                    </span>
                                                </a>
                                            </li>
                                            )}  
                                            {canMassiveDownload && this.state.total_excluding_status_1 > 0 && (
                                            <li class="navi-item  li-actions">
                                                <a  className={`navi-link py-4 ${this.state.total === 0 ? 'disabled' : ''}`} onClick={(e) => {
                                                    if (this.state.total === 0) {
                                                        e.preventDefault();
                                                    } else {
                                                        this.handleExportClick('document');
                                                    }
                                                }}> 
                                                    <span className="navi-icon mr-5 text-center">
                                                        <span className="flaticon-download text-primary icon-md"></span>
                                                    </span>
                                                    <span className="navi-text text-secondary">Descarga Masiva<br></br>
                                                    <span className="text-muted">({this.state.total_excluding_status_1} documentos)</span>
                                                    </span>
                                                    
                                                    <span className="navi-icon pull-right">
                                                        <button className="btn btn-icon btn-light btn-xs bg-white">
                                                            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                        </button>
                                                    </span>
                                                </a>
                                            </li> )}
                                            {/* Submenú Exportar */}
                                            {canExportExtraFieldsReportColumns && (
                                            this.state.total_sat > 0 ||
                                            this.state.total_imss > 0 ||
                                            this.state.total_repse > 0 ||
                                            this.state.total_infonavit > 0 ||
                                            this.state.total_constancias > 0
                                            ) &&  
                                            <li className="navi-item li-actions">
                                                <a className="navi-link py-4" onClick={(e) => e.stopPropagation()} data-toggle="dropdown">
                                                    <span className="navi-icon mr-5 text-center">
                                                        <span className="flaticon-download text-primary icon-md"></span>
                                                    </span>
                                                    <span className="navi-text text-secondary">Exportar Reporte Campos Extra con Columna
                                                    </span>
                                                    <span className="navi-icon pull-right">
                                                        <button className="btn btn-icon btn-light btn-xs bg-white">
                                                            <i className="flaticon2-down weight-normal text-primary icon-sm"></i>
                                                        </button>
                                                    </span>
                                                </a>
                                                <ul className="dropdown-menu">
                                                {this.state.total_constancias > 0 &&
                                                    <li className="navi-item over">
                                                        <a className="navi-link py-4" onClick={(e) => { e.stopPropagation(); this.handleExportClick('constancia'); }}>
                                                            <i className="icon-md mr-2 text-primary weight-normal flaticon2-file-1"></i>
                                                            <span className="navi-text text-secondary">Constancia de Situación Fiscal &nbsp;
                                                                <span className="text-muted">({this.state.total_constancias})</span> 
                                                            </span>
                                                        </a>
                                                    </li>
                                                    }
                                                    {this.state.total_sat > 0 &&
                                                    <li className="navi-item over">
                                                        <a className="navi-link py-4" onClick={(e) => { e.stopPropagation(); this.handleExportClick('sat'); }}>
                                                            <i className="icon-md mr-2 text-primary weight-normal flaticon2-file-1"></i>
                                                            <span className="navi-text text-secondary">Opinión  de Cumplimiento del SAT &nbsp;
                                                                <span className="text-muted">({this.state.total_sat})</span> 
                                                            </span>
                                                        </a>
                                                    </li>
                                                    }
                                                    {this.state.total_imss > 0 &&
                                                    <li className="navi-item over">
                                                        <a className="navi-link py-4" onClick={(e) => { e.stopPropagation(); this.handleExportClick('imss'); }}>
                                                            <i className="icon-md mr-2 text-primary weight-normal flaticon2-file-1"></i>
                                                            <span className="navi-text text-secondary">Opinion de Cumplimiento del IMSS &nbsp;
                                                                <span className="text-muted">({this.state.total_imss})</span> 
                                                            </span>
                                                        </a>
                                                    </li>
                                                    }
                                                    {this.state.total_repse > 0 &&
                                                    <li className="navi-item over">
                                                        <a className="navi-link py-4" onClick={(e) => { e.stopPropagation(); this.handleExportClick('repse'); }}>
                                                            <i className="icon-md mr-2 text-primary weight-normal flaticon2-file-1"></i>
                                                            <span className="navi-text text-secondary">Opinion de Cumplimiento del REPSE &nbsp;
                                                                <span className="text-muted">({this.state.total_repse})</span> 
                                                            </span>
                                                        </a>
                                                    </li>
                                                    }
                                                    {this.state.total_infonavit > 0 &&
                                                    <li className="navi-item over">
                                                        <a className="navi-link py-4" onClick={(e) => { e.stopPropagation(); this.handleExportClick('infonavit'); }}>
                                                            <i className="icon-md mr-2 text-primary weight-normal flaticon2-file-1"></i>
                                                            <span className="navi-text text-secondary">Opinion de Cumplimiento del INFONAVIT &nbsp;
                                                                <span className="text-muted">({this.state.total_infonavit})</span> 
                                                            </span>
                                                        </a>
                                                    </li>
                                                    }
                                                    
                                                </ul>
                                            </li>
                                            }
                                        </ul>
                                    </div> 
                                </div> 
                            </div>
                        }
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="datatable-filters">
                        <div className="d-flex justify-content-between mb-4">
                            <div className="font-weight-bolder">{lang.get('messages.filtrar_por')}</div>
                            <a
                                className="datatable-clear-filters float-right text-primary"
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.clearFilters();
                                }}
                            ><strong>{lang.get('messages.limpiar_todos_los_filtros')}</strong></a>
                        </div>
                        <div className="d-flex justify-content-between mb-4 default">
                            <div className="col-md-4">
                                <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.tipo_de_expediente')}</label>
                                <Select
                                    value={this.state.filters.tipo_expediente
                                        ? {
                                            value: this.state.filters.tipo_expediente,
                                            label: this.getLabelByValue(
                                                this.state.filters.tipo_expediente,
                                                dossierTypeOptions
                                            )
                                        }
                                        : null
                                    }
                                    onChange={(selectedOption) =>
                                        this.updateFilters('tipo_expediente', selectedOption?.value || null)
                                    }
                                    options={dossierTypeOptions}
                                    placeholder={<div>{lang.get('messages.tipo_de_expediente')}</div>}
                                    isClearable
                                />
                            </div>
                            <div className="col-md-4">
                                <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.nombre_del_archivo')}</label>
                                <Select
                                    value={this.state.filters.document_id ? { 
                                        value: this.state.filters.document_id, 
                                        label: this.state.documentTitles.find(doc => doc.id === this.state.filters.document_id)?.title 
                                    } : null}
                                    onChange={(selectedOption) => 
                                        this.updateFilters('document_id', selectedOption?.value || null)
                                    }
                                    options={this.state.documentTitles.map(documentTitle => ({ value: documentTitle.id, label: documentTitle.title }))}
                                    placeholder={<div>{lang.get('messages.buscar_por_nombre')}</div>}
                                    isClearable
                                />
                                
                            </div> 
                            <div className="col-md-4">
                                <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.extension')}</label>
                                <Select
                                    value={this.state.filters.extension 
                                        ? { 
                                            value: this.state.filters.extension, 
                                            label: this.getLabelByValue(
                                                this.state.filters.extension, 
                                                Object.entries(this.state.options.extensions).map(([key, label]) => ({
                                                    value: key,
                                                    label: label
                                                }))
                                            ) 
                                        } 
                                        : null
                                    }
                                    onChange={(selectedOption) => 
                                        this.updateFilters('extension', selectedOption?.value || null)
                                    }
                                    options={Object.entries(this.state.options.extensions).map(([key, label]) => ({
                                        value: key,
                                        label: label
                                    }))}
                                    placeholder={<div>{lang.get('messages.extension')}</div>}
                                    isClearable
                                />
                            </div> 
                        </div>
                        {this.state.showAdvancedFilters && (
                            <>
                            <div className="advanced-filters">
                                <div className="d-flex justify-content-between mb-4 default">
                                    <div className="col-md-4">
                                        <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.frecuencia')}</label>
                                        <Select value={this.state.filters.frequency 
                                                ? { 
                                                    value: this.state.filters.frequency, 
                                                    label: this.getLabelByValue(
                                                        this.state.filters.frequency, 
                                                        Object.entries(this.state.options.frequency).map(([key, label]) => ({
                                                            value: key,
                                                            label: label
                                                        }))
                                                    ) 
                                                } 
                                                : null
                                            }
                                            onChange={(selectedOption) => 
                                                this.updateFilters('frequency', selectedOption?.value || null)
                                            }
                                            options={Object.entries(this.state.options.frequency).map(([key, label]) => ({
                                                value: key,
                                                label: label
                                            }))}
                                            placeholder={<div>{lang.get('messages.frecuencia')}</div>}
                                            isClearable
                                        />
                                    </div> 
                                    <div className="col-md-4">
                                        <label className="mb-0 text-dark-50 font-weight-bold">Estatus</label>
                                        <Select value={this.state.filters.status ? { 
                                                        value: this.state.filters.status, label: this.getLabelByValue(this.state.filters.status, 
                                                            Object.entries(this.state.options.status)
                                                            .filter(([key]) => !(this.state.options.rejectedFiles && key === "4"))
                                                            .map(([key, label]) => ({
                                                                value: key,
                                                                label: label
                                                            }))
                                                    ) 
                                                }   : null
                                            }
                                            onChange={(selectedOption) => 
                                                this.updateFilters('status', selectedOption?.value || null)
                                            }
                                            options={Object.entries(this.state.options.status)
                                                .filter(([key]) => this.state.filters.showRejectedFiles || key !== "4")
                                                .map(([key, label]) => ({ 
                                                    value: key, 
                                                    label: label 
                                                }))}  placeholder={<div>Estatus</div>}
                                            isClearable
                                        />
                                    </div> 
                                    <div className="col-md-4">
                                        <div className="datepicker-container">
                                            <label className="mb-0 text-dark-50 font-weight-bold">Fecha Inicio de Periodo</label><br></br>
                                            <div style={{ position: 'relative' }}>
                                                <div
                                                    className="form-control d-flex align-items-center justify-content-between"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={this.toggleDatePicker}
                                                >
                                                    <span>{this.state.startDate ? moment(this.state.startDate).format('ll') : lang.get('messages.fecha_inicio')}</span>
                                                    <span className="mx-2">–</span>
                                                    <span>{this.state.endDate ? moment(this.state.endDate).format('ll') : lang.get('messages.fecha_fin')}</span>
                                                    {(this.state.startDate || this.state.endDate) && (
                                                        <span onClick={(e) => { e.stopPropagation(); this.clearDates(); }} style={{ marginLeft: 'auto' }}>
                                                            <i className="flaticon2-delete text-muted"></i>
                                                        </span>
                                                    )}
                                                </div>

                                                {this.state.showDatePicker && (
                                                    <div ref={this.datePickerRef} className="date-range-popover">
                                                        <DateRange
                                                            ranges={[{
                                                                startDate: this.state.startDate ? new Date(this.state.startDate) : new Date(),
                                                                endDate: this.state.endDate ? new Date(this.state.endDate) : new Date(),
                                                                key: 'selection'
                                                            }]}
                                                            onChange={this.handleDateChange}
                                                            editableDateInputs={true}
                                                            moveRangeOnFirstSelection={false}
                                                            months={1}
                                                            direction="horizontal"
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="advanced-filters">
                                <div className="d-flex justify-content-between mb-4 default">
                                    <div className="col-md-4">
                                        <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.plantilla_de_expediente')}</label>
                                        <Select
                                            value={this.state.filters.dossier_id ? { 
                                                value: this.state.filters.dossier_id, 
                                                label: this.state.dossierTitles.find(doc => doc.id === this.state.filters.dossier_id)?.title 
                                            } : null}
                                            onChange={(selectedOption) => 
                                                this.updateFilters('dossier_id', selectedOption?.value || null)
                                            }
                                            options={this.state.dossierTitles.map(dossierTitle => ({ value: dossierTitle.id, label: dossierTitle.title }))}
                                            placeholder={<div>{lang.get('messages.buscar_por_plantilla_de_expediente')}</div>}
                                            isClearable
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.tipo')}</label>
                                        <Select value={this.state.filters.type 
                                                ? { 
                                                    value: this.state.filters.type, 
                                                    label: this.getLabelByValue(
                                                        this.state.filters.type, 
                                                        Object.entries(this.state.options.type).map(([key, label]) => ({
                                                            value: key,
                                                            label: label
                                                        }))
                                                    ) 
                                                } 
                                                : null
                                            }
                                            onChange={(selectedOption) => 
                                                this.updateFilters('type', selectedOption?.value || null)
                                            }
                                            options={Object.entries(this.state.options.type).map(([key, label]) => ({
                                                value: key,
                                                label: label
                                            }))}
                                            placeholder={<div>{lang.get('messages.buscar_por_tipo')}</div>}
                                            isClearable
                                        />
                                    </div> 
                                    <div className="col-md-4">
                                        <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.relacion')}</label>
                                        <Select value={this.state.filters.target 
                                                ? { 
                                                    value: this.state.filters.target, 
                                                    label: this.getLabelByValue(
                                                        this.state.filters.target, 
                                                        Object.entries(this.state.options.target).map(([key, label]) => ({
                                                            value: key,
                                                            label: label
                                                        }))
                                                    ) 
                                                } 
                                                : null
                                            }
                                            onChange={(selectedOption) => 
                                                this.updateFilters('target', selectedOption?.value || null)
                                            }
                                            options={Object.entries(this.state.options.target).map(([key, label]) => ({
                                                value: key,
                                                label: label
                                            }))}
                                            placeholder={<div>{lang.get('messages.buscar_por_relacion')}</div>}
                                            isClearable
                                        />
                                    </div> 
                                    
                                </div>
                            </div>
                            <div className="d-flex justify-content-between mb-4 default">
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.razon_social')}</label>
                                    <Select
                                            value={this.state.filters.fiscal_name_id ? { 
                                                value: this.state.filters.fiscal_name_id, 
                                                label: this.state.fiscalNames?.find(doc => doc.id === this.state.filters.fiscal_name_id)?.title 
                                            } : null}
                                            onChange={(selectedOption) => 
                                                this.updateFilters('fiscal_name_id', selectedOption?.value || null)
                                            }
                                            options={this.state.fiscalNames?.map(fiscalName => ({ value: fiscalName.id, label: fiscalName.title }))}
                                            placeholder={<div>{lang.get('messages.buscar_por_plantilla_de_expediente')}</div>}
                                            isClearable
                                        />
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.rfc')}</label>
                                    <Select
                                            value={this.state.filters.rfc_id ? { 
                                                value: this.state.filters.rfc_id, 
                                                label: this.state.rfcs?.find(doc => doc.id === this.state.filters.rfc_id)?.rfc 
                                            } : null}
                                            onChange={(selectedOption) => 
                                                this.updateFilters('rfc_id', selectedOption?.value || null)
                                            }
                                            options={this.state.rfcs?.map(fiscalName => ({ value: fiscalName.id, label: fiscalName.rfc }))}
                                            placeholder={<div>{lang.get('messages.buscar_por_rfc')}</div>}
                                            isClearable
                                        />
                                </div>
                                <div className="col-md-4 pt-4">
                                        <div className="checkbox-inline">
                                            <label className="checkbox checkbox-outline mb-7">
                                                <input type="checkbox"
                                                    checked={this.state.filters.showRejectedFiles} 
                                                    onChange={(e) => this.updateFilters('showRejectedFiles', e.target.checked)} />
                                                    <span className="w-25px h-25px mt-2 rounded-0"></span>
                                                    <p className="mt-5">Mostrar documentos con estatus Rechazado</p>
                                            </label>
                                        </div>
                                    </div>
                            </div>
                            </>
                        )}
                        <div className="d-flex justify-content-between">
                        {this.state.showAdvancedFilters == false &&
                            <div className="my-4">
                                <a href="#"
                                className="text-primary font-weight-bold"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.toggleAdvancedFilters();
                                }}>
                                    <span className="flaticon2-down mr-2"></span> {lang.get('messages.mostrar_filtros_avanzados')}
                                </a>
                            </div>
                        } 
                        {this.state.showAdvancedFilters == true &&
                            <div className="my-4">
                                <a href="#"
                                className="text-primary font-weight-bold"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.toggleAdvancedFilters();
                                }}>
                                    <span className="flaticon2-up mr-2"></span> {lang.get('messages.ocultar_filtros_avanzados')}
                                </a>
                            </div>
                        }
                        <div className="icon-container">
                            <i class="flaticon-settings-1 icon-lg mr-3 text-primary"   onClick={() => this.setState({ showColumnSelector: true })}  ></i>

                            {this.state.showColumnSelector && (
                                <div className="column-selector">
                                    {Object.keys(this.state.columns_head).map((column, index) => (
                                        <div className="d-flex checkbox-inline form-group gap-1 mb-3 align-items-center" key={index}>
                                            <label className="checkbox checkbox-lg checkbox-square"> 
                                            <input 
                                                type="checkbox" 
                                                checked={this.state.columns_head[column]} 
                                                onChange={() => this.toggleColumnVisibility(column)} 
                                            />
                                            <span></span>
                                            {columnNames[column]} 
                                            </label>
                                        </div>
                                    ))}
                                    <button className="btn btn-secondary" onClick={() => this.setState({ showColumnSelector: false })}>Cerrar</button>
                                </div>
                            )}
                        </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid"> 
                    <div className="table-responsive">
                    <table className="table table-report w-100" id="datatable">
                        <thead>
                            <tr>  
                                {this.state.columns_head['file.title_head'] && 
                                    <th>{lang.get('messages.plantilla_de_documento')} </th>
                                }
                                {this.state.columns_head['dossier'] && 
                                    <th>{lang.get('messages.tipo_de_expediente')} </th>
                                }
                                {this.state.columns_head['extension'] && 
                                <th>{lang.get('messages.extension')} </th>
                            }
                                {this.state.columns_head['frequency'] && 
                                <th>{lang.get('messages.frecuencia')} </th>
                            }
                                {this.state.columns_head['status'] && 
                                <th>{lang.get('messages.estatus')} </th>
                            }
                                {this.state.columns_head['document_template'] && 
                                <th>{lang.get('messages.plantilla_de_expediente')} </th>
                            }
                                {this.state.columns_head['relation'] && 
                                <th>{lang.get('messages.relacion')} </th>
                            }
                                {this.state.columns_head['type'] && 
                                <th>{lang.get('messages.tipo')} </th>
                            }
                                {this.state.columns_head['fiscal_name'] && 
                                <th>{lang.get('messages.razon_social')} </th>
                            }
                                {this.state.columns_head['rfc'] && 
                                <th>{lang.get('messages.rfc')} </th>
                            }
                                {this.state.columns_head['fields'] && 
                                <th>{lang.get('messages.campos_extras')} </th>
                            }
                                {this.state.columns_head['requested_date'] && 
                                <th>{lang.get('messages.fecha_inicio_periodo')}     </th>
                            }
                                {this.state.columns_head['upload_date'] && 
                                <th>{lang.get('messages.fecha_de_carga')} </th>
                            }
                            {this.state.columns_head['rejected_message'] && 
                                <th>{lang.get('messages.motivo_de_rechazo')} </th> 
                            }
                            <th></th>
                            </tr> 
                            </thead>
                            <tbody>
                            {this.state.documents.map((document, index) =>   {
                                const documentActionUrl = this.getDocumentActionUrl(document);

                                return (
                                    <tr key={index}>
                                        {this.state.columns_head['file.title_head'] && 
                                            <td>{document.document.title}</td>
                                            
                                        }
                                        {this.state.columns_head['dossier'] && 
                                        <td>
                                            {document.provider.type === 1 && 'Externos'}
                                            {document.provider.type === 2 && 'Internos'}
                                            {document.provider.type === 3 && 'Propios'}
                                        </td>
                                        }
                                        {this.state.columns_head['extension'] && 
                                        <td>{document.file?.extension || 'N/A'}</td>
                                        }
                                        {this.state.columns_head['frequency'] && 
                                        <td>
                                            {document.document.frequency === 'once' && 'Único'}
                                            {document.document.frequency === 'yearly' && 'Recurrente'}
                                        </td>
                                        }
                                        {this.state.columns_head['status'] && 
                                        <td>
                                            {statusName(document)}
                                        </td>
                                        }
                                        {this.state.columns_head['document_template'] && 
                                        <td>
                                            {documentActionUrl ? (
                                                <a
                                                    href={documentActionUrl}
                                                    target="_blank"
                                                    className="text-primary font-weight-bold"
                                                    title="Abrir expediente"
                                                >
                                                    {document.dossier.title}
                                                </a>
                                            ) : (
                                                document.dossier.title
                                            )}
                                        </td>
                                        }
                                        {this.state.columns_head['relation'] && 
                                        <td>{document.dossier.target.name}</td>
                                        }   
                                        {this.state.columns_head['type'] && 
                                        <td>{document.dossier.type.title}</td>
                                        }
                                        {this.state.columns_head['fiscal_name'] && 
                                        <td>{document.people.fiscal_name}</td>
                                        }
                                        {this.state.columns_head['rfc'] && 
                                        <td>{document.people.rfc}</td>
                                        }
                                        {this.state.columns_head['fields'] && 
                                        <td>
                                            {document.document.fields?.length > 0 && (
                                                <div className="document-fields-container">
                                                    {!this.state.shownFields[document.id] ? (
                                                        <a href="#" 
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            this.toggleFields(document.id);
                                                        }}
                                                        className="text-primary font-weight-bold">
                                                            Mostrar Campos
                                                        </a>
                                                    ) : (
                                                        <>
                                                            <a href="#" 
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                this.toggleFields(document.id);
                                                            }}
                                                            className="text-primary font-weight-bold mb-2 d-block">
                                                                Ocultar Campos
                                                            </a>
                                                            <div className="fields-list">
                                                                {document.document.fields.map((field, index) => {
                                                                    const fieldValue = document.document_field_values.find(
                                                                        dv => dv.document_fields_id === field.id
                                                                    );
                                                                    return fieldValue ? (
                                                                        <div key={index} className="field-item">
                                                                            <strong>{(document.document.type_id >= 5 && document.document.type_id <= 15 ? field.placeholder : field.title)}  :</strong>
                                                                            <span className="ml-2">{fieldValue.document_field_value}</span>
                                                                        </div>
                                                                    ) : null;
                                                                })}
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            )}
                                        </td>
                                        }
                                        {this.state.columns_head['requested_date'] && 
                                        <td>{document.start_date} </td>
                                        }
                                        {this.state.columns_head['upload_date'] && 
                                        <td>{document.upload_date.created} </td>
                                        }
                                        <td>
                                        {(this.state.columns_head['rejected_message'] && document.status.id === 4) && 
                                            <>
                                            {document.status_comment}  
                                        </>
                                        }
                                        </td>
                                        <td>
                                            {((document.provider.type === 1 || document.provider.type === 3) && document.status.id !== 1 &&
                                                (this.props.permissions.documents_actions.includes('all') || this.props.permissions.documents_actions.includes('individual_download'))) ? (
                                                <>
                                                    {documentActionUrl && (
                                                        <a
                                                            href={documentActionUrl}
                                                            target="_blank"
                                                            className="btn btn-icon btn-light btn-xs mr-2"
                                                            title="Abrir documento"
                                                        >
                                                            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                        </a>
                                                    )}
                                                    <a
                                                        href={`/files/${document.id}`}
                                                        target="_blank"
                                                        download
                                                        className="btn btn-icon btn-light btn-xs mr-2"
                                                        title="Descargar documento"
                                                    >
                                                        <i className="flaticon2-download text-primary"></i>
                                                    </a>
                                                </>
                                            ) : null}

                                            {((document.provider.type == 2) && document.status.id !== 1 &&
                                                (this.props.permissions.documents_actions_internal.includes('all') || this.props.permissions.documents_actions_internal.includes('individual_download'))) ? (
                                                <a
                                                    href={`/files/${document.id}`}
                                                    target="_blank"
                                                    download
                                                    className="btn btn-icon btn-light btn-xs mr-2"
                                                    title="Descargar documento"
                                                >
                                                    <i className="flaticon2-download text-primary"></i>
                                                </a>
                                            ) : null}
                                        </td>
                                         
                                    </tr>
                                );
                            })}
                            </tbody>
                    </table>
                   
                    {this.state.documents.length === 0 && (
                        <div className="text-center p-10 mt-5">
                            {Object.keys(this.state.filters).length > 0 ? (
                                <p>No se encontraron documentos con los filtros seleccionados.
                                    <br></br>
                                     Intenta ajustar los filtros o restablecerlos para ver más resultados.</p>
                            ) : (
                                <p>No hay documentos disponibles.</p>
                            )}
                        </div>
                    )}
 
                       {this.state.documents.length > 0 && (
                    <SimplePagination  updateCurrentPage={this.updateCurrentPage}  currentPage={this.state.page}   totalFiles={this.state.total} split={this.state.maxRecords}/>
                       )}
                    </div>
                </div> 
            </>
        );
    }
    getLabelByValue(value, options) {
        const option = options.find(option => option.value === value);
        return option ? option.label : '';
    }
}
export default ReportsDocuments;
